// extracted by mini-css-extract-plugin
export default {"lang-switcher":"lang-switcher_lang-switcher__d8MYw"};